"use client";
import { Button } from "@frontend/shared/components/ui/button";
import { cn } from "@frontend/shared/lib/utils";
import { Loader2 } from "lucide-react";
import { useFormContext } from "react-hook-form";
import type { SubmitButtonProps } from "../../[clientSlug]/types";

interface SubmitButtonComponentProps {
  style: string;
  props: SubmitButtonProps;
}

export function SubmitButtonComponent({
  style,
  props,
}: SubmitButtonComponentProps) {
  const form = useFormContext();
  const { buttonId, text, loadingText } = props;

  if (!form) {
    console.warn("SubmitButtonComponent must be used within a form provider");
    return null;
  }

  const isSubmitting = form.formState.isSubmitting;

  return (
    <Button
      id={buttonId}
      type="submit"
      disabled={isSubmitting}
      className={cn(style)}
    >
      {isSubmitting ? (
        <div className="flex flex-row items-center gap-2">
          <Loader2 className="animate-spin" size={20} />
          <span>{loadingText || "Submitting..."}</span>
        </div>
      ) : (
        text
      )}
    </Button>
  );
}
